import { useState } from 'react';
import { IonTextarea } from '@ionic/react';
import classnames from 'classnames';

export default function ValidatedTextarea({setValue, valid, ...props}) {
  const [touched, setTouched] = useState(false);
  return (
    <IonTextarea
      onIonInput={(e) => setValue(e.target.value)}
      onIonBlur={(e) => setTouched(true)}
      className={classnames({'ion-valid': valid, 'ion-invalid': !valid, 'ion-touched': touched})}
      labelPlacement="floating"
      autoGrow
      {...props}/>
  );
}
